import accountSubCategory from './accountSubCategory';
import appearanceSubCategory from './appearanceSubCategory';
import advertisingSubCategory from './advertisingSubCategory';
import categoriesSubCategory from './categoriesSubCategory';
import configurationSubCategory from './configurationSubCategory';
import exportSubCategory from './exportSubCategory';
import mobileSubCategory from './mobileSubCategory';
import notificationsSubCategory from './notificationsSubCategory';
import premiumDashboardSubCategory from './premiumDashboardSubCategory';
import skypeSubCategory from './skypeSubCategory';
import storageSubCategory from './storageSubCategory';
var generalCategory = {
    key: 'general',
    titleStringKey: 'optionCategory_General',
    icon: "Settings" /* Settings */,
    subcategories: [
        accountSubCategory,
        appearanceSubCategory,
        notificationsSubCategory,
        categoriesSubCategory,
        configurationSubCategory,
        skypeSubCategory,
        premiumDashboardSubCategory,
        mobileSubCategory,
        storageSubCategory,
        exportSubCategory,
        advertisingSubCategory,
    ],
};
export default generalCategory;
//# sourceMappingURL=category.js.map